<template>
  <div class="footer">
    <div class="width1000 margintb">
      <p class="banquan">慈 善 网 版 权 所 有 ，未 经 书 面 授 权 禁 止 使 用</p>
      <p class="info">Copyright © 1997-2020 by www.cszg365.com all rights reserved</p>
      <p class="info linkHref">
        <a href="https://beian.miit.gov.cn/"
           target="_blank">京ICP备11033129号-1</a>
      </p>
      <!-- <div class="imgList">
        <a href=""><img src="@/assets/images/copy_icon1.jpg" /></a>
        <a href=""><img src="@/assets/images/copy_icon2.jpg" /></a>
        <a href=""><img src="@/assets/images/copy_icon3.jpg" /></a>
        <a href=""><img src="@/assets/images/copy_icon4.jpg" /></a>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less">
.footer {
  margin-top: 30px;
  margin-bottom: 100px;
  .banquan {
    text-align: center;
  }
  .info {
    text-align: center;
  }
  .linkHref {
    margin: 2px 0;
  }
  .imgList {
    margin-top: 20px;
    text-align: center;
    a {
      margin-right: 30px;
    }
  }
}
</style>
